// actions/types.js
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const SET_TITLE = 'SET_TITLE';
export const SET_DESCRIPTION = 'SET_DESCRIPTION';
export const SET_PAGE = 'SET_PAGE';
export const SET_PARENT_PAGE = 'SET_PARENT_PAGE';

export const CREATE_COMPANY = 'CREATE_COMPANY';
export const RETRIEVE_COMPANIES = 'RETRIEVE_COMPANIES';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const DOWNLOAD_TEMPLATE = 'DOWNLOAD_TEMPLATE';
export const PARSE_EXCEL = 'PARSE_EXCEL';
export const BULK_CREATE_COMPANIES = 'BULK_CREATE_COMPANIES';

export const CREATE_PlANT = 'CREATE_PLANT';
export const RETRIEVE_PLANTS = 'RETRIEVE_PLANTS';
export const UPDATE_PLANT = 'UPDATE_PLANT';
export const DOWNLOAD_PLANT_TEMPLATE = 'DOWNLOAD_PLANT_TEMPLATE';
export const PARSE_PLANT_EXCEL = 'PARSE_PLANT_EXCEL';
export const BULK_CREATE_PLANTS = 'BULK_CREATE_PLANTS';
export const EXPORT_PLANTS = 'EXPORT_PLANTS';

export const CREATE_PRODUCT = 'CREATE_PRODUCT';
export const RETRIEVE_PRODUCTS = 'RETRIEVE_PRODUCTS';
export const RETRIEVE_ACTIVE_PRODUCTS = 'RETRIEVE_ACTIVE_PRODUCTS';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const DOWNLOAD_PRODUCT_TEMPLATE = 'DOWNLOAD_PRODUCT_TEMPLATE';
export const PARSE_PRODUCT_EXCEL = 'PARSE_PRODUCT_EXCEL';
export const BULK_CREATE_PRODUCTS = 'BULK_CREATE_PRODUCTS';

export const CREATE_ROLE = 'CREATE_ROLE';
export const RETRIEVE_ROLES = 'RETRIEVE_ROLES';
export const UPDATE_ROLE = 'UPDATE_ROLE';

export const CREATE_USER = 'CREATE_USER';
export const RETRIEVE_USER = 'RETRIEVE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DOWNLOAD_USER_TEMPLATE = 'DOWNLOAD_USER_TEMPLATE';
export const PARSE_USER_EXCEL = 'PARSE_USER_EXCEL';
export const BULK_CREATE_USERS = 'BULK_CREATE_USERS';

export const CREATE_ISSUE_TYPE = 'CREATE_ISSUE_TYPE';
export const RETRIEVE_ISSUE_TYPE = 'RETRIEVE_ISSUE_TYPE';
export const UPDATE_ISSUE_TYPE = 'UPDATE_ISSUE_TYPE';
export const RETRIEVEACTIVE_ISSUE_TYPE = 'RETRIEVEACTIVE_ISSUE_TYPE';

export const RETRIEVE_ISSUE_CATEGORY = 'RETRIEVE_ISSUE_CATEGORY';
export const CREATE_ISSUE_CATEGORY = 'CREATE_ISSUE_CATEGORY';
export const UPDATE_ISSUE_CATEGORY = 'UPDATE_ISSUE_CATEGORY';
export const GETACTIVE_ISSUE_CATEGORY = 'GETACTIVE_ISSUE_CATEGORY';

export const CREATE_CASE = 'CREATE_CASE';
export const RETRIEVE_CASE_ADMIN = 'RETRIEVE_CASE_ADMIN';
export const GET_ALL_CASE = 'GET_ALL_CASE';
export const GET_ALL_CASE_VALIDATE = 'GET_ALL_CASE_VALIDATE';
export const CANCEL_CASE_BY_ADMIN = 'CANCEL_CASE_BY_ADMIN';
export const UPDATE_CATE_BY_ADMIN = 'UPDATE_CATE_BY_ADMIN';
export const UPDATE_CASE_PRIORITY = 'UPDATE_CASE_PRIORITY';

export const GETMY_CASE = 'GETMY_CASE';
export const CANCEL_MY_CASE = 'CANCEL_MY_CASE';
export const APPROVAL_MY_CASE = 'APPROVAL_MY_CASE';

export const GETSEND_EMAIL = 'GETSEND_EMAIL';

export const RETRIEVE_RESPONSIBLE_CASE_ID = 'RETRIEVE_RESPONSIBLE_CASE_ID';

export const CREATE_TASK = 'CREATE_TASK';

export const RETRIEVE_MY_TASK = 'RETRIEVE_MY_TASK';
export const RETRIEVE_MY_TASK_DETAIL = 'RETRIEVE_MY_TASK_DETAIL';
export const ACCEPT_NEW_TASK = 'ACCEPT_NEW_TASK';
export const CANCEL_TASK = 'CANCEL_TASK';
export const SEND_SOLVING_TASK = 'SEND_SOLVING_TASK';

export const RETRIEVE_PRODUCT_GROUPS = 'RETRIEVE_PRODUCT_GROUPS';
export const CREATE_PRODUCT_GROUPS = 'CREATE_PRODUCT_GROUPS';
export const UPDATE_PRODUCT_GROUPS = 'UPDATE_PRODUCT_GROUPS';

export const RETRIEVE_PRODUCT_OWNER_REPORT = 'RETRIEVE_PRODUCT_OWNER_REPORT';

export const RETRIEVE_DASHBOARD = 'RETRIEVE_DASHBOARD';

export const RETRIEVE_PRIORITIES = 'RETRIEVE_PRIORITIES';
export const CREATE_PRIORITY = 'CREATE_PRIORITY';
export const UPDATE_PRIORITY = 'UPDATE_PRIORITY';
export const DELETE_PRIORITY = 'DELETE_PRIORITY';

export const CREATE_HOLIDAY = 'CREATE_HOLIDAY';
export const RETRIEVE_HOLIDAYS = 'RETRIEVE_HOLIDAYS';
export const UPDATE_HOLIDAY = 'UPDATE_HOLIDAY';
export const DELETE_HOLIDAY = 'DELETE_HOLIDAY';

// Service Type Actions
export const CREATE_SERVICE_TYPE = 'CREATE_SERVICE_TYPE';
export const RETRIEVE_SERVICE_TYPES = 'RETRIEVE_SERVICE_TYPES';
export const UPDATE_SERVICE_TYPE = 'UPDATE_SERVICE_TYPE';
export const DOWNLOAD_SERVICE_TYPE_TEMPLATE = 'DOWNLOAD_SERVICE_TYPE_TEMPLATE';
export const PARSE_SERVICE_TYPE_EXCEL = 'PARSE_SERVICE_TYPE_EXCEL';
export const BULK_CREATE_SERVICE_TYPES = 'BULK_CREATE_SERVICE_TYPES';

export const DOWNLOAD_SERVICE_CATEGORY_TEMPLATE = 'DOWNLOAD_SERVICE_CATEGORY_TEMPLATE';
export const PARSE_SERVICE_CATEGORY_EXCEL = 'PARSE_SERVICE_CATEGORY_EXCEL';
export const BULK_CREATE_SERVICE_CATEGORIES = 'BULK_CREATE_SERVICE_CATEGORIES';

export const RETRIEVE_SERVICE_CATEGORIES = 'RETRIEVE_SERVICE_CATEGORIES';
export const RETRIEVE_JOB_ROLES = 'RETRIEVE_JOB_ROLES';
export const CREATE_JOB_ROLE = 'CREATE_JOB_ROLE';
export const UPDATE_JOB_ROLE = 'UPDATE_JOB_ROLE';
export const RETRIEVE_USERS_BY_JOB_ROLE = 'RETRIEVE_USERS_BY_JOB_ROLE';
export const ASSIGN_USER_TO_JOB = 'ASSIGN_USER_TO_JOB';
export const UNASSIGN_USER_FROM_JOB = 'UNASSIGN_USER_FROM_JOB';
export const UNASSIGN_USER_FROM_JOB_BY_USER_ID = 'UNASSIGN_USER_FROM_JOB_BY_USER_ID';
export const SEARCH_USERS = 'SEARCH_USERS';

export const RETRIEVE_SERVICE_APPROVALS = 'RETRIEVE_SERVICE_APPROVALS';
export const RETRIEVE_FINAL_REVIEWERS = 'RETRIEVE_FINAL_REVIEWERS';
export const RETRIEVE_FINAL_APPROVALS = 'RETRIEVE_FINAL_APPROVALS';

export const CREATE_SERVICE_APPROVAL = 'CREATE_SERVICE_APPROVAL';
export const UPDATE_SERVICE_APPROVAL = 'UPDATE_SERVICE_APPROVAL';
export const DELETE_SERVICE_APPROVAL = 'DELETE_SERVICE_APPROVAL';

export const CREATE_FINAL_REVIEWER = 'CREATE_FINAL_REVIEWER';
export const UPDATE_FINAL_REVIEWER = 'UPDATE_FINAL_REVIEWER';
export const DELETE_FINAL_REVIEWER = 'DELETE_FINAL_REVIEWER';

export const CREATE_FINAL_APPROVER = 'CREATE_FINAL_APPROVER';
export const UPDATE_FINAL_APPROVER = 'UPDATE_FINAL_APPROVER';
export const DELETE_FINAL_APPROVER = 'DELETE_FINAL_APPROVER';

export const RETRIEVE_ESTIMATE_EFFORT_REVIEWERS = 'RETRIEVE_ESTIMATE_EFFORT_REVIEWERS';
export const CREATE_ESTIMATE_EFFORT_REVIEWER = 'CREATE_ESTIMATE_EFFORT_REVIEWER';
export const UPDATE_ESTIMATE_EFFORT_REVIEWER = 'UPDATE_ESTIMATE_EFFORT_REVIEWER';
export const DELETE_ESTIMATE_EFFORT_REVIEWER = 'DELETE_ESTIMATE_EFFORT_REVIEWER';
